import {
    Box, Button, CardContent, FormControl, FormControlLabel, Switch, TextField, Typography
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import api from '../../../services/api';
import React, { Component } from 'react';
import { validateField } from 'lib/functions';
import { isInvalidSelect } from 'lib/configUtils';
import ComboPadrao from 'views/Components/ComboPadrao';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class ModeloVeiculoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isNewRecord: false,
            isView: false,
            marcasveiculos: [],
            modeloveiculo: {
                codmodeloveiculo: '',
                codmarcaveiculo: '',
                descmodeloveiculo: '',
                autonomiakmperc: 0,
                inativo: ANAO
            },
            errors: {},
            schema: {
                descmodeloveiculo: {
                    presence: { allowEmpty: false, message: 'Descrição do modelo obrigatória' },
                    length: { maximum: 64 },
                    type: 'string'
                },
                codmarcaveiculo: {
                    presence: { allowEmpty: false, message: 'Marca de veículo obrigatória' },
                    length: { maximum: 64 },
                    type: 'integer'
                }
            }
        };
    };

    async componentDidMount() {
        const { id } = this.props.match.params;
        const { history, location } = this.props;
        const currentPath = location.pathname;

        try {
            if (!isNaN(Number(id))) {
                const response = await api.get(`/modeloveiculo/${id}`);
                const registro = response?.data?.data?.[0];

                if (!registro) {
                    this.handleOpenAlert('Modelo de veículo não encontrado!');
                    history.push('/frotas/modeloveiculo');
                    return;
                }

                const marcasveiculos = await api.get(`/marcaveiculo/listforchange/${registro.codmarcaveiculo}`);

                this.setState({
                    modeloveiculo: {
                        codmodeloveiculo: registro.codmodeloveiculo || '',
                        codmarcaveiculo: registro.codmarcaveiculo || '',
                        descmodeloveiculo: registro.descmodeloveiculo || '',
                        autonomiakmperc: registro.autonomiakmperc ?? 0,
                        inativo: registro.inativo || ANAO
                    },
                    isNewRecord: false,
                    isView: currentPath.includes('/view'),
                    marcasveiculos: marcasveiculos.data.data || []
                });
            } else if (id === 'novo') {
                const marcasveiculos = await api.get(`/marcaveiculo/active/true`);

                this.setState({
                    isNewRecord: true,
                    isView: false,
                    modeloveiculo: {
                        codmodeloveiculo: '',
                        codmarcaveiculo: '',
                        descmodeloveiculo: '',
                        autonomiakmperc: 0,
                        inativo: ANAO,
                    },
                    marcasveiculos: marcasveiculos.data.data || []
                });

                return;
            }
        } catch (error) {
            console.error('Erro ao carregar modelo de veículo:', error.response?.data || error.message);
            this.handleOpenAlert(error.response?.data?.error || 'Erro ao carregar modelo de veículo!');
        }
    };

    /* Evento on change componentes */
    OnChange = (event) => {
        const { name, type, value, checked } = event.target;

        // ajuste de campos (código existente)
        let adjustedValue =
            type === 'checkbox' ? (checked ? ANAO : ASIM) :
                type === 'radio' ? Number(value) : value.toUpperCase();

        this.setState(prevState => ({
            modeloveiculo: {
                ...prevState.modeloveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Atualiza dados de modelo de veículo existente - post */
    atualizaModeloVeiculo = async () => {
        const { modeloveiculo } = this.state;
        try {
            const response = await api.put(`/modeloveiculo/${modeloveiculo.codmodeloveiculo}`, modeloveiculo);
            if (response.status === 200) {
                this.props.history.push('/frotas/modeloveiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Click salvar */
    onClickSave = async () => {
        const { modeloveiculo, isNewRecord } = this.state;
        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!')
            return;
        }

        // validação extra para ComboPadrao obrigatório
        const comboFields = [
            {
                field: 'codmarcaveiculo',
                message: 'Selecione uma marca de veículo válida'
            }
        ];

        const comboErrors = {};

        comboFields.forEach(({ field, message }) => {
            if (isInvalidSelect(modeloveiculo[field])) {
                comboErrors[field] = message;
            }
        });

        if (Object.keys(comboErrors).length > 0) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    ...comboErrors
                }
            }));

            this.handleOpenAlert('Selecione registros válidos nos campos indicados em vermelho!');

            return;
        }

        try {
            const codusuarioregistrou = sessionStorage.getItem('codUser') || localStorage.getItem('codUser');
            if (!codusuarioregistrou) {
                console.error('Erro: código do usuário não encontrado!');
                return;
            }

            // usa-se quando não há campos do tipo BLOB
            const payload = {
                codmarcaveiculo: modeloveiculo.codmarcaveiculo || '',
                descmodeloveiculo: modeloveiculo.descmodeloveiculo || '',
                inativo: modeloveiculo.inativo || '',
                autonomiakmperc: modeloveiculo.autonomiakmperc !== '' ? Number(modeloveiculo.autonomiakmperc) : 0, // Usa-se para padrão 0
                codusuarioregistrou: Number(codusuarioregistrou)
            };

            console.log('Enviando para o backend (JSON):', payload);

            if (isNewRecord) {
                await api.post('/modeloveiculo', payload);
            } else {
                await api.put(`/modeloveiculo/${modeloveiculo.codmodeloveiculo}`, payload);
            }

            if (this.props.loadModelosVeiculo) this.props.loadModelosVeiculo();
            this.props.history.push('/frotas/modeloveiculo');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);
            this.handleOpenAlert(error.response?.data?.error || 'Erro ao salvar!');
        }
    };

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/modeloveiculo');
    };

    /* Valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { modeloveiculo, schema } = this.state;
        let errors = {};

        // valida campos do schema
        const requiredFields = [
            'descmodeloveiculo',
            'codmarcaveiculo'
        ]

        requiredFields.forEach(field => {
            const error = validateField(field, modeloveiculo[field], schema);
            if (error) {
                errors[field] = error;
            }
        })

        return errors;
    };

    /* Insere novo modelo de veículo */
    insereModeloVeiculo = async () => {
        const { modeloveiculo } = this.state;
        modeloveiculo.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));
        try {
            const response = await api.post(`/modeloveiculo`, modeloveiculo);
            if (response.status === 200) {
                this.props.history.push('/frotas/modeloveiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    render() {
        const {
            errors,
            isView,
            marcasveiculos,
            messageAlert,
            modeloveiculo,
            openAlert
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Modelo de veículos {modeloveiculo.codmodeloveiculo}
                        </Typography>

                        <FormControlLabel
                            label={(modeloveiculo.inativo === ASIM) ? 'Inativo' : 'Ativo'}
                            control={
                                <Switch
                                    checked={!(modeloveiculo.inativo === ASIM)}
                                    name="inativo"
                                    onChange={this.OnChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    <TextField
                        label="Descrição"
                        name="descmodeloveiculo"
                        value={modeloveiculo.descmodeloveiculo || ''}
                        variant="outlined"
                        onChange={this.OnChange}
                        helperText={errors.descmodeloveiculo || ''}
                        error={!!errors.descmodeloveiculo}
                        disabled={isView}
                        inputProps={{ maxLength: 50 }}
                        style={{
                            marginTop: '10px',
                            width: '70%'
                        }}
                    />

                    <br />

                    <FormControl
                        fullWidth
                        variant="outlined"
                        disabled={isView}
                        style={{
                            width: '35%',
                            marginRight: '1rem',
                            marginTop: '17px'
                        }}
                    >
                        <ComboPadrao
                            name={'codmarcaveiculo'}
                            label={'Marca de veículo'}
                            value={modeloveiculo.codmarcaveiculo}
                            onChange={this.OnChange}
                            helperText={errors.codmarcaveiculo || ''}
                            error={!!errors.codmarcaveiculo}
                            fieldId={'codmarcaveiculo'}
                            listItems={marcasveiculos}
                            fieldDescription={'descmarcaveiculo'}
                        />
                    </FormControl>

                    <FormControl
                        fullWidth
                        variant="outlined"
                        disabled={isView}
                        style={{
                            width: '367px',
                            marginTop: '17px'
                        }}
                    >
                        <TextField
                            label="Autonomia de KM percorrido"
                            name="autonomiakmperc"
                            value={modeloveiculo.autonomiakmperc || ''}
                            variant="outlined"
                            disabled={isView}
                            type="number"
                            inputProps={{
                                min: 0,
                                maxLength: 50
                            }}
                            onChange={(e) => {
                                const { value } = e.target;
                                const numero = Number(value);
                                if (numero < 0) return;
                                this.OnChange(e);
                            }}
                        />
                    </FormControl>

                    <br />
                    <br />
                    <br />

                    <Box
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 10
                        }}
                    >
                        <Button
                            name="salvar"
                            color="primary"
                            variant="contained"
                            onClick={this.onClickSave}
                            disabled={isView}
                        >
                            Salvar
                        </Button>

                        <Button
                            name="cancelar"
                            variant="contained"
                            onClick={this.onClickCancel}
                            color="secondary"
                        >
                            Cancelar
                        </Button>
                    </Box>
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div>
        );
    }
}

export default ModeloVeiculoForm;